import { createStyles } from '@material-ui/core/styles';

export const styles = () =>
  createStyles({
    root: {
      color: '#D92D20',
      fill: 'transparent',
      fontSize: 16,
    },
  });
